export default "__VITE_ASSET__19283d3c__"